import { ActivityLogParser } from '@/parsers/activityLog'

export class ContractActivityLogParser extends ActivityLogParser {
    static attributeDataTypes = {
        'termination_date': 'date',
    }
}
